// PROMPT 147: la burbuja de una plantilla (encabezado en negrita, cuerpo, pie gris y botones).
// La usan el hilo del chat y la vista previa de ElegirPlantilla: lo que se ve antes de mandar
// es lo que queda en la conversacion.
import { partesFormato } from "@/lib/plantillasWa";

// *negrita*, _cursiva_ y ~tachado~ como en WhatsApp.
export function TextoFormateado({ texto }) {
  return (
    <>
      {partesFormato(texto).map((x, i) => {
        if (x.e === "*") return <strong key={i}>{x.t}</strong>;
        if (x.e === "_") return <em key={i}>{x.t}</em>;
        if (x.e === "~") return <s key={i}>{x.t}</s>;
        return <span key={i}>{x.t}</span>;
      })}
    </>
  );
}

// `partes`: {encabezado, cuerpo, pie, botones} (lo que arma el servidor y guarda en el mensaje).
// Sin `partes` (un mensaje viejo) se muestra el texto tal cual.
export function BloquePlantilla({ partes, texto, nombre }) {
  const botones = ((partes && partes.botones) || []).filter(Boolean);
  return (
    <div className="px-1.5 pt-1" data-testid="wa-plantilla-bloque">
      {nombre ? (
        <div className="mb-0.5 text-[11px] font-medium text-slate-500" data-testid="wa-plantilla-rotulo">
          Plantilla · {nombre}
        </div>
      ) : null}
      {partes ? (
        <>
          {partes.encabezado ? (
            <div className="whitespace-pre-wrap break-words text-[14px] font-bold leading-[19px] text-[#111b21]">
              {partes.encabezado}
            </div>
          ) : null}
          {partes.cuerpo ? (
            <div className="whitespace-pre-wrap break-words text-[14px] leading-[19px] text-[#111b21]">
              <TextoFormateado texto={partes.cuerpo} />
            </div>
          ) : null}
          {partes.pie ? (
            <div className="mt-1 whitespace-pre-wrap break-words text-[12px] leading-[16px] text-slate-500">
              {partes.pie}
            </div>
          ) : null}
          {botones.length ? (
            <div className="mt-1.5 space-y-1 border-t border-black/10 pt-1.5">
              {botones.map((b, i) => (
                <div
                  key={i}
                  className="rounded bg-black/5 px-2 py-1 text-center text-[13px] font-medium text-sky-700"
                >
                  {b}
                </div>
              ))}
            </div>
          ) : null}
        </>
      ) : (
        <div className="whitespace-pre-wrap break-words text-[14px] leading-[19px] text-[#111b21]">{texto}</div>
      )}
    </div>
  );
}
